import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "../apiClient";

export const putBusCourse = ({ id, ...data }) => {
  return api.put(`admin/bus-courses-v2/${id}`, data);
};

export const usePutBusCourseMutation = ({ mutationConfig }) => {
  const queryClient = useQueryClient();

  const { onSuccess, ...restConfig } = mutationConfig || {};

  return useMutation({
    onSuccess: async (data, ...args) => {
      await onSuccess?.(data, ...args);
      queryClient.resetQueries();
    },
    ...restConfig,
    mutationFn: putBusCourse,
  });
};
